import axios from "axios";
import { PortalModel } from "@apps/mf-overview/src/server/portals/model";

/**
 * Returns all models that a user is authorized to access.
 */
export async function getPortalsForUser(): Promise<PortalModel[]> {
  const [{ data: portals }] = await Promise.all([
    await axios.get<PortalModel[]>("/portalList"),
  ]);

  return portals ?? [];
}
